import React from 'react'
import PropTypes from 'prop-types'
import { css } from 'linaria'

import { useTranslation } from '@/hooks/I18nProvider'

const styles = css`
  /* Mobile: Logo más pequeño */
  @apply max-w-2xl w-full mx-auto p-4 pt-0 flex items-center
  relative sticky top-0;
  min-width: 300px;
  z-index: 1;

  /* Desktop */
  @apply md:p-6 md:px-0 md:flex-col md:justify-center md:items-start md:bg-gray-100;

  & > .logo {
    /* Mobile */
    @apply rounded-full w-10 h-10 border-solid border border-gray-300 m-0;
    
    /* Desktop */
    @apply md:w-20 md:h-20 md:ml-3;
    background: #ececec;

    &.with-link {
      @apply cursor-pointer;
    }

    & > img {
      @apply rounded-full object-cover object-center;
      aspect-ratio: 1/1;
    }
  }

  header {
    /* Mobile */
    @apply my-1 pl-4 relative;
    
    /* Desktop */
    @apply md:px-4;
    
    h1 {
      /* Mobile */
      @apply text-gray-700 font-bold text-base mt-0;

      /* Desktop */
      @apply md:text-2xl md:mt-3;

      span {
        @apply text-2xl block;
      }
    }
  }


  > h2 {
    /* Mobile */
    @apply hidden;
 
    /* Desktop */
    @apply md:inline-block text-xs bg-gray-100 rounded-full px-4 text-gray-500;
    width: fit-content;
  }

  & > div.estimated {
    @apply mt-4;
    & p {
      @apply font-bold text-sm text-gray-500 mb-2;
    }
  }
`

const Header = ({
  estimated,
  storeImageUrl,
  storeName,
  orderType,
  orderId,
  withoutBottom,
  storeUrl,
}) => {
  const { t } = useTranslation()

  return (
    <div className={`${styles} ${withoutBottom ? 'without-bottom' : ''}`}>
      <div
        className={`logo ${storeUrl ? 'with-link' : ''}`}
        onClick={() => {
          if (storeUrl) {
            window.location.replace(storeUrl || '')
          }
        }}
      >
        <img src={storeImageUrl || '/images/n1co-icon.svg'} />
      </div>
      <header className={Object.keys(estimated).length ? 'has-estimated' : ''}>
        {storeName && <h1>{storeName}</h1>}
        {estimated.description && (
        <div className="estimated">
          {estimated.date && (
          <p>
            {t`header.datetimeDeliveryTitle`}
          </p>
          )}
          <h1>
            {estimated.date && (
            <>
              {estimated.date}
              <span>{estimated.time}</span>
            </>
            )}
            <span>{estimated.description}</span>
          </h1>
        </div>
        )}
      </header>
      {orderId && (
      <h2>
        <span>{orderType}</span>
        {' '}
        {orderId}
      </h2>
      )}
    </div>
  )
}

Header.propTypes = {
  estimated: PropTypes.shape({
    date: PropTypes.string,
    time: PropTypes.string,
    description: PropTypes.string,
  }),
  storeImageUrl: PropTypes.string,
  storeName: PropTypes.string,
  orderType: PropTypes.string,
  orderId: PropTypes.string,
  withoutBottom: PropTypes.bool,
  storeUrl: PropTypes.string,
}

Header.defaultProps = {
  estimated: {},
  storeImageUrl: '',
  storeName: '',
  orderType: 'Orden',
  orderId: null,
  withoutBottom: false,
  storeUrl: null,
}

export default Header

export { default as Sidebar } from './Sidebar'
